import React, {useEffect, useState} from 'react';
import Validator from '../../../util/validator';
import {useTranslation} from 'react-i18next';
import {useStylesECDS} from './ecds/ecdsStyle';
import moment from 'moment';
import {useDispatch, useSelector} from 'react-redux';
import {hasOneOfPermission, Permissions, user} from '../../../store/reducers/user';
import ReferralsOtherServices from './ecds/referralsOtherServices';
import _ from 'lodash';
import Notes from '../../../util/notes';
import Formatter from '../../../util/formatter';
import AgyleDialog from '../../../components/modal/agyleDialog';
import {setWorkflow} from '../../../store/reducers/workflow';
import {getConfig} from '../../../util/configUtil';
import {WORKFLOW_OPTIONS} from '../../../util/workflowUtil';
import {patientBanner} from '../../../controls/agyle/tasks/components/patientBanner';

const ReferralsForm = (props) => {
    const classes = useStylesECDS();
    const {t} = useTranslation();
    const dispatch = useDispatch();

    // Form data
    const [otherService, setOtherService] = useState(null);
    const [originReferrals, setOriginReferrals] = useState(null);

    const userObject = useSelector(user);
    const tester = Formatter.formatUserFullName(userObject);

    const validation = (min, max, data) => Validator.validEcdsFormLenght(min, max, data);

    const canEditReferrals = dispatch(hasOneOfPermission([Permissions.AGYLE_CAN_MANAGE_REFERRALS]));
    const [formIsModified, setFormIsModified] = React.useState(false);

    // Init original referral list
    // Needed to specify deleted referrals for a clinician notes
    useEffect(() => {
        if (props.patient?.studies?.referrals?.ReferralsToOtherServices) {
            setOriginReferrals(props.patient.studies.referrals.ReferralsToOtherServices);
        }
    }, []);

    useEffect(() => {
        if (props.onSubmitFunction) {
            props.onSubmitFunction(submit);
        }
        if (props.onDisableSubmit) {
            props.onDisableSubmit(!formIsModified || props.disableSave);
        }
    }, [formIsModified, props.patient, props.disableSave, otherService, props.fromAdmit]);

    const prepareNote = () => {
        return Notes.getReferralsNote(otherService, originReferrals);
    };

    const submit = (e) => {
        if (e) e.preventDefault();
        if (!props.disableSave && !_.isEqual(props.patient?.studies?.referrals?.ReferralsToOtherServices, otherService?.ReferralsToOtherServices)) {
            const dateOfForm = moment().toISOString();

            const data = ([{
                name: props.fromAdmit ? 'specialty' : 'studies.referrals',
                value: {
                    ...otherService,
                    by: tester,
                    login: userObject?.userName,
                    date: dateOfForm,
                },
                noteToAdd: prepareNote(),
            }]);
            props.onChange(data);
        }

        if (getConfig('clinicalConclusionFormMandatory') && !props?.patient?.clinicalConclusion
            && !_.isEmpty(props.patient?.diagnosis?.primary) && !_.isEmpty(otherService?.ReferralsToOtherServices)) {
            dispatch(setWorkflow({type: WORKFLOW_OPTIONS.CLINICAL_CONCLUSION}));
        }

        if (props.close) props.close();
    };

    if (!props.modal) {
        return (
            <ReferralsOtherServices
                cannotEdit={!canEditReferrals}
                setData={setOtherService}
                style={classes}
                patient={props.patient}
                checkLenght={validation}
                valid
                saveData={() => setFormIsModified(true)}
                isBB={false}
                formContext
                {...props}
            />
        );
    }

    return (
        <AgyleDialog
            title={t('Speciality Referral')}
            open={props.open}
            onClose={props.close}
            closeButtonOnHeader
            width="lg"
            fullWidth
            onSave={submit}
            disableSubmit={!formIsModified}
        >
            {props.patientInfo &&
                patientBanner(props.patient, true)
            }
            <ReferralsOtherServices
                cannotEdit={!canEditReferrals}
                setData={setOtherService}
                style={classes}
                patient={props.patient}
                checkLenght={validation}
                valid={true}
                saveData={() => setFormIsModified(true)}
                isBB={props.isBB}
            />
        </AgyleDialog>
    );
};

export default ReferralsForm;
